'use strict';

const h = require('phy');

const EnrollmentIframe = ({ iframeLoading, iframeRef }) => {
  return h(
    iframeLoading ? 'div.gig-spinner.gig-spinner-brnd' : 'div',
    h('iframe', {
      id: 'select-enrollment-iframe',
      ref: iframeRef,
      scrolling: 'no',
      sandbox: 'allow-forms allow-popups allow-same-origin allow-scripts',
      title: 'Select Enrollment Popup',
      frameBorder: 0,
    })
  );
};

module.exports = EnrollmentIframe;
